import { render, staticRenderFns } from "./NewCollapseItem.vue?vue&type=template&id=6a321360&"
import script from "./NewCollapseItem.vue?vue&type=script&lang=js&"
export * from "./NewCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports